module.exports = __webpack_public_path__ + "static/img/logo_top_white.40bf63f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/svg/logo_top_white.svg
// module id = y+IC
// module chunks = 5